module.exports = __webpack_public_path__ + "static/our-identity-5f80e2aff9dc060df31756adb899cbc9.png";